/* eslint-disable react/destructuring-assignment */
import React, { useContext } from 'react';
import { styled } from '@abyss/ui/tools/styled';
import { useForm } from '@abyss/ui/form/hooks/useForm';
// import { useTechnicalUser } from 'src/state/technicalUser';
// import { useAlerts } from 'src/state/alerts';
import { FormControl } from '@abyss/ui/form/FormControl';
import { TextInput } from '@abyss/ui/form/TextInput';
import { ErrorMessage } from '@abyss/ui/form/ErrorMessage';
import { Button } from 'src/common/Button';
import { Flex } from '@abyss/ui/base/Flex';
import { usePasswordOwner } from 'src/hooks/usePasswordOwner';
import { useUserLookup } from 'src/hooks/useUserLookup';
import { AlertContext } from 'src/tools/AlertContext';

const ActionButtons = styled.div({
  marginTop: 25,

  '> *:first-child': {
    marginRight: 12,
  },
});

export const FindForm = () => {
  const form = useForm();
  const errorContext = useContext(AlertContext);

  const [, getUserLookup] = useUserLookup({
    onCompleted: emulatedUser => {
      form.load('emulation.emulatedUser', emulatedUser);
      if (emulatedUser.acceptedTerms === false) {
        errorContext.addAlert({
          ...emulatedUser,
          id: 'technical-user-get-user-info',
          code: 'TNC_NOT_ACCEPTED',
          type: 'warning',
        });
      }
    },
    onError: error => {
      errorContext.addAlert(error);
    },
  });

  const [, getPasswordOwner] = usePasswordOwner({
    onCompleted: data => {
      const emulatedUser = data[0] || {};

      if (emulatedUser.user_type === 'IA') {
        errorContext.addAlert({
          message:
            'The Primary Access Administrator (PAA) for this MPIN is inactive. We have chosen an Individual Administrator (IA) for you to proceed. This does not include access to Third Party Requests or Paperless Options.',
        });
      }

      form.load('emulation.emulatedUser', emulatedUser);
      form.load('internalPreference', {
        uuid: emulatedUser.optum_uuid,
        ohid: emulatedUser.optum_id,
      });

      getUserLookup({
        variables: {
          id: emulatedUser.optum_uuid,
        },
      });
    },
    onError: error => {
      errorContext.addAlert({
        ...error,
        message:
          'The Primary Access Administrator (PAA) and Individual Administrator (IA) for this MPIN is inactive or there are no users registered. Please select another MPIN to continue.',
      });
    },
  });

  const handleFind = () => {
    form.reset('internalPreference');
    form.reset('emulation.emulatedUser');
    form.submit('emulation.mpin', mpin => {
      getPasswordOwner({
        variables: JSON.stringify({
          corpMpin: mpin,
        }),
      });
    });
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleFind();
    }
  };

  const handleReset = () => {
    form.reset('emulation');
    form.reset('internalPreference');
    form.reset('utility.corporateProvider');
    form.reset('utility.taxIdNumber');
    form.reset('utility.servicingProvider');
  };

  return (
    <Flex gutters-horizontal onKeyDown={handleKeyDown}>
      <Flex.Content space-25>
        <FormControl
          id="mpin-input"
          model="emulation.mpin"
          label="MPIN"
          required
        >
          {(inputProps, errorProps) => (
            <React.Fragment>
              <TextInput
                {...inputProps}
                data-cy="mpin-input"
                autoFocus
                validators={{ required: value => !value }}
              />
              <ErrorMessage
                {...errorProps}
                messages={{ required: 'Please enter an mpin.' }}
              />
            </React.Fragment>
          )}
        </FormControl>
      </Flex.Content>
      <Flex.Content>
        <ActionButtons>
          <Button
            data-testid="find-button"
            data-cy="find-button"
            onClick={handleFind}
            // isLoading={getPasswordOwner.saga.isLoading}
          >
            Find
          </Button>
          <Button
            data-testid="reset-button"
            data-cy="reset-button"
            variant="outline"
            onClick={handleReset}
          >
            Reset
          </Button>
        </ActionButtons>
      </Flex.Content>
    </Flex>
  );
};
